export default "__VITE_ASSET__BIcDcdBj__"